var appElement = document.querySelector('#app');
var appBase = appElement && appElement.getAttribute('appbase') || '/';
__webpack_public_path__ = appBase + 'dist/';